import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {Link} from 'gatsby';

function Solution(props) {
    return (
        <div className="services_solution  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5}>
                        <div className="example" data-text="Work With CTO">
                            <h2>Work With A Seasoned CTO!</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="offset-lg-1">
                        <p>Our C-level tech executives have enabled startups to enterprise-grade businesses to harness
                            the power of technological change.</p>
                        <p>Here are critical business cases we can help you with: IT infrastructure roadmap and
                            implementation, identifying digital transformation and disruption opportunities, risk
                            assessment and mitigation, cloud architecture and migration, technical product design,
                            development, and lifecycle, high-end project delivery and testing, and cybersecurity audits
                            and implementations.</p>
                        <p>Want our CTO to augment your team?</p>
                         <Link to="/contact"
                              className="border_btn" aria-label="TekRevol Contact">Let's Connect!</Link>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Solution;